import { render } from "./CaseStudyGrid.vue?vue&type=template&id=73b22c14&bindings={\"caseStudies\":\"props\",\"small_title\":\"props\",\"title\":\"props\",\"subtitle\":\"props\"}"
import script from "./CaseStudyGrid.vue?vue&type=script&lang=js"
export * from "./CaseStudyGrid.vue?vue&type=script&lang=js"
script.render = render

export default script